import { $uniDebug } from "../uni-debug.module"
import { IUniConfig } from "../../uni-base-module"

class TitleDevDirective implements ng.IDirective {
  restrict: "A"
  scope: {
    titleDev: "@"
    t: "@"
  }
  priority: number = -999

  constructor(
    private $log: ng.ILogService,
    private $timeout: ng.ITimeoutService,
    private UniConfig: IUniConfig
  ) {
    this.restrict = "A"
    this.scope = {
      titleDev: "@",
      t: "@"
    }
  }

  compile(element: JQLite, attrs: ng.IAttributes) {
    this.$log.debug("******** Compile", element.html())

    if (!this.UniConfig.debug) {
      attrs.titleDev = "????"
      element.removeAttr("title-dev")
    }

    return this.link
  }

  link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrls: ng.IController) {
    // $log.debug("Instanciando TitleDevDirective", scope);

    if (this.UniConfig.debug) {
      // this.$log.debug("Activando titleDev", element);
      this.$timeout(() => {
        if (attrs.titleDev.indexOf('"acts"') >= 0) {
          this.$log.debug("Estableciendo title-dev", attrs)
        }
        element.attr("title", attrs.titleDev)
        element.removeAttr("title-dev")

        if (attrs.t) {
          element.addClass("small if__dev")
          element.html(attrs.t)
        }
      }, 2000)
    }
  }
}

$uniDebug.directive("titleDev", [
  "$log",
  "$timeout",
  "UniConfig",
  ($log, $timeout, UniConfig) =>
    new TitleDevDirective($log, $timeout, UniConfig)
])
